import { useState, useEffect } from 'react'
import BaseService from 'services/BaseService'

export function useAxiosLoader() {
    const [count, setCount] = useState(0)

    useEffect(() => {
        const inc = () => setCount(c => c + 1)
        const dec = () => setCount(c => c - 1)

        const reqInterceptor = BaseService.interceptors.request.use(config => {
            inc()
            return config
        }, error => {
            dec()
            return Promise.reject(error)
        })

        const resInterceptor = BaseService.interceptors.response.use(response => {
            dec()
            return response
        }, error => {
            dec()
            return Promise.reject(error)
        })

        return () => {
            BaseService.interceptors.request.eject(reqInterceptor)
            BaseService.interceptors.response.eject(resInterceptor)
        }
    }, [])

    return count > 0
}

export default useAxiosLoader
